import { Box, Flex, Text } from "@chakra-ui/react";
import { palette } from "./theme";

export const MetricRows = ({ rows }: { rows: string[][] }): JSX.Element => (
  <Box display="grid">
    {rows.map(([name, value, description]) => (
      <Flex
        key={name}
        justify="space-between"
        align="center"
        gap={3}
        py={3}
        borderBottom={`1px solid ${palette.border}`}
      >
        <Box minW={0}>
          <Text fontSize="13px" fontWeight="850">
            {name}
          </Text>
          <Text color={palette.muted} fontSize="11px">
            {description}
          </Text>
        </Box>
        <Text fontSize="13px" fontWeight="900" whiteSpace="nowrap">
          {value}
        </Text>
      </Flex>
    ))}
  </Box>
);
